<template>
    <Field :name="name" v-slot="{ field, errors }" v-bind="fieldValidateOn">
        <DatetimeInput
            v-model="field.value"
            @update:modelValue="field['onUpdate:modelValue']"
            @blur="field.onBlur"
            :errorMessages="errors"
            :field-error="!isEmpty(errors)"
            v-bind="input" />
    </Field>
</template>
<script lang="ts">
    import { PropType, ExtractPropTypes, defineComponent, inject } from 'vue';
    import { FieldValidateOn } from '../../Validations/Validations.interfaces';
    import { Field } from 'vee-validate';
    import { isEmpty } from 'lodash';
    import DatetimeInput from './DatetimeInput.vue';
    type DatetimeInputProps = ExtractPropTypes<typeof DatetimeInput.props>;
    export default defineComponent({
        name: 'DatetimeInputField',
        methods: { isEmpty },
        components: { Field, DatetimeInput },
        props: {
            name: {
                type: String,
                required: true,
            },
            input: {
                type: Object as PropType<Partial<DatetimeInputProps>>,
                default: () => ({}),
            },
        },
        setup() {
            const fieldValidateOn = inject('fieldValidateOn') as FieldValidateOn;
            return { fieldValidateOn };
        },
    });
</script>
